var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "h-100 pa-16px",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-row', {
    staticClass: "h-100 align-end align-lg-center",
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-img', {
    staticClass: "w-70 w-lg-100 mx-auto mb-14px mb-lg-0",
    attrs: {
      "max-width": "320",
      "src": "/images/main/venaseal.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 justify-center ml-lg-40px"
  }, [_c('u-tit-default', {
    staticClass: "font-size-12 font-size-md-24 font-size-lg-36"
  }, [_c('span', {
    staticClass: "font-weight-regular font-secondary"
  }, [_vm._v("베나실")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-16 font-size-md-36 font-size-lg-48"
  }, [_vm._v(" "), _c('ICountUp', {
    staticClass: "iCountUp",
    attrs: {
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": _vm.duration,
      "options": _vm.options
    },
    on: {
      "ready": _vm.onReady
    }
  })], 1), _vm._v("례 이상 ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }